import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { ChartDataPoint } from '@/hooks/useChartData'
import { useChartAxisTheme } from '@/hooks/useThemeColors'

export interface ConversionChartProps {
  chartData: ChartDataPoint[]
  visibleLines: Record<string, boolean>
}

export function ConversionChart({
  chartData,
  visibleLines
}: ConversionChartProps) {
  // Сетка и оси recharts красятся SVG-атрибутами — CSS-переменная там не разрешается.
  const chartTheme = useChartAxisTheme()

  return (
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <CartesianGrid {...chartTheme.grid} />
          <XAxis dataKey="date" {...chartTheme.axis} />
          <YAxis {...chartTheme.axis} />
          <Tooltip
            labelFormatter={(label) => label}
            formatter={(value: number, name: string) => {
              const labels: Record<string, string> = {
                cr1: 'Заявка → Запись',
                cr2: 'Запись → Приход',
                cr3: 'Приход → Продажа',
                crTotal: 'Общая (Заявка → Продажа)'
              }
              return [`${value.toFixed(1)}%`, labels[name] || name]
            }}
          />
          <Line
            type="monotone"
            dataKey="cr1"
            name="cr1"
            stroke="#FF9800"
            strokeWidth={2}
            dot={{ r: 3 }}
            opacity={visibleLines.cr1 ? 1 : 0.2}
            strokeDasharray={visibleLines.cr1 ? '0' : '5 5'}
          />
          <Line
            type="monotone"
            dataKey="cr2"
            name="cr2"
            stroke="#9C27B0"
            strokeWidth={2}
            dot={{ r: 3 }}
            opacity={visibleLines.cr2 ? 1 : 0.2}
            strokeDasharray={visibleLines.cr2 ? '0' : '5 5'}
          />
          <Line
            type="monotone"
            dataKey="cr3"
            name="cr3"
            stroke="#2196F3"
            strokeWidth={2}
            dot={{ r: 3 }}
            opacity={visibleLines.cr3 ? 1 : 0.2}
            strokeDasharray={visibleLines.cr3 ? '0' : '5 5'}
          />
          <Line
            type="monotone"
            dataKey="crTotal"
            name="crTotal"
            stroke="#4CAF50"
            strokeWidth={2}
            dot={{ r: 3 }}
            opacity={visibleLines.crTotal ? 1 : 0.2}
            strokeDasharray={visibleLines.crTotal ? '0' : '5 5'}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
